import React from 'react';
import Card from '../Card';
import './Advantages.css';
import img1 from '../../img/001.jpg';
import img2 from '../../img/0032.jpg';
import img3 from '../../img/002.jpg';


const Advantages = () => {
  const advantageCards = [
    {
      image: img1,
      title: "КОМФОРТНОЕ ПРОЖИВАНИЕ 24/7",
      description: "Уютный гостевой дом в черте города Уфы, в котором легко организовать свой ночлег, приготовить пищу и просто приятно провести свободное время"
    },
    {
      image: img2,
      title: "ПОСТАНОВКА НА МИГРАЦИОННЫЙ УЧЕТ",
      description: "Мы сможем сделать все в электронной форме, без необходимости вашего личного присутствия. Гарантируем результат и соблюдение всех сроков"
    },
    {
      image: img3,
      title: "ВРЕМЕННАЯ РЕГИСТРАЦИЯ В УФЕ",
      description: "Поможем собрать все необходимые документы и справки, заполнить формы и подать заявление РВП, в дальнейшем можно обсудить и ВНЖ"
    }
  ];

  return (
    <section className="advantages" id="preimushestva">
      <div className="container">
        <div className="advantages-content">
          <div className="section-spacer"></div>
          
          <div className="advantages-header">
            <h2 className="advantages-title">
              МЫ ДАЕМ ВАМ НАДЕЖНОЕ ЖИЛЬЕ<br />
              <span className="advantages-subtitle">
                и оказываем расширенные услуги миграционного учета
              </span>
            </h2>
          </div>
          
          <div className="advantages-grid">
            {advantageCards.map((card, index) => (
              <div className="advantages-col" key={index}>
                <Card
                  image={card.image}
                  title={card.title}
                  description={card.description}
                />
              </div>
            ))}
          </div>
          
          <div className="section-spacer-bottom"></div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;